// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__14ZUO","label":"Completed_label__1TIQ_"};